export default {
  state: {
    flag: false,
    msg: '',
  },
  mutations: {
    undoError: (state: any) => {
      state.flag = false;
    },
    onError: (state: any, msg: any) => {
      state.msg = msg;
      state.flag = true;
    },
  },
};
